export enum ItemType {
	article = "article",
	category = "category",
}
